import { LegacyGalleryResource } from "./LegacyGalleryResource"
import { fetchGet, ErrorCallback, fetchPost } from "../common/Requests"
import { LegacyGallerySaveParams } from "./LegacyGallerySaveParams"
import { Gallery } from "./Gallery"
import API from "../common/API"

type GallerySuccessCallback = (json: LegacyGalleryResource) => void
type DateRange = { from: Date, to: Date }

export enum GallerySortType {
  NEWEST = "newest",
  POPULAR = "popular",
  DATES = "dates"
}

export function fetchGallery(
  galleryCode: string,
  sortType: GallerySortType,
  numberOfUploads: number,
  dates: DateRange | null,
  handleSuccess: GallerySuccessCallback,
  handleError: ErrorCallback) {
  fetchGet(
    resolveInitialFetchLink(API.baseUrl, galleryCode, sortType, dates, numberOfUploads),
    (json) => {
      if (json.id) {
        handleSuccess(json as LegacyGalleryResource)
      } else if (json.private) {
        handleError(401)
      } else {
        handleError(404)
      }
    },
    handleError
  )
}

export function fetchMoreGalleryUploads(link: string, handleSuccess: GallerySuccessCallback, handleError: ErrorCallback) {
  fetchGet(link, handleSuccess, handleError)
}

function formatIsoUtcDateString(date: Date) {
  return `${date.getUTCFullYear()}-${date.getUTCMonth() + 1}-${date.getUTCDate()}`
}

function resolveInitialFetchLink(
  baseUrl: string,
  galleryCode: string,
  sortType: GallerySortType,
  dates: DateRange | null,
  numberOfUploads: number): string {

  let params = new URLSearchParams()
  params.append("number", numberOfUploads.toString())
  params.append("offset", "0")

  if (sortType == GallerySortType.DATES) {
    if (!dates) {
      throw new Error("You must provide the to and from dates to sort that way.")
    }

    params.append("from", formatIsoUtcDateString(dates.from))
    params.append("to", formatIsoUtcDateString(dates.to))
  } else {
    params.append("sort", sortType)
  }

  return `${baseUrl}/gallery/${galleryCode}/json?${params.toString()}`
}

export function saveGallery(
  gallery: Gallery,
  topImageFile: File | null,
  bottomImageFile: File | null,
  handleSuccess: (json: any) => void,
  handleError: ErrorCallback) {

  let saveParams = new LegacyGallerySaveParams(gallery.code)
  saveParams.title = gallery.title
  saveParams.hashtag = gallery.hashtag
  saveParams.topImageFile = topImageFile
  saveParams.bottomImageFile = bottomImageFile
  let body = saveParams.toFormData()

  fetchPost(
    `${API.baseUrl}/ajax/gallery-save.php`,
    body,
    handleSuccess,
    handleError
  )
}
